import { useMutation } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

import { ItemAiChatError, itemAiChatErrorMessage } from './itemAiChatError';

export const useOpenItemAiChat = () =>
  useMutation({
    mutationFn: async ({ declarationId, goodsShipmentItemId }: { declarationId: string; goodsShipmentItemId: string }) => {
      const result = await apiClient.itemAiChat.openItemAiChat.mutation({
        params: { declarationId, goodsShipmentItemId },
        body: undefined,
      });
      if (result.status !== 200) throw new ItemAiChatError(result.status);
      return result.body;
    },
    onError: (error) => {
      showErrorToast(error, itemAiChatErrorMessage(error));
    },
  });
